import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import ReactSelect2 from '../../elements/ReactSelect2Wrapper'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'
import {createClientTarification, fetchClientTarifications, setClientSubModule, setOpenedSubmenu, fetchClientTarification} from 'state/actions'
import cs from 'classnames'
import styles from './clientTarificationCreate.scss'

const _ = i18n('clientTarificationCreate')

const customStylesForModal = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

const fieldsForFill = {
    selectedBroker: '',
    tarificationTeam: '',
}

/**
 * Resetable state hierarchy and values for this module.
 */
 const resetableState = {
    allFieldDisabled: true,
    tarificationId: '',
    tarification: false,
    waitingModal: false,
    validationErrors: {},
    hasError: false,
    ...fieldsForFill
}

/**
 * Default state hierarchy and values for this module.
 */
 let permanentState = {
    brokerOptions: [],
}

@connect(state => {
    let clientAccess = state.app.security.actions
    let canCreateMifid = false
    const clientOptionsDict = state.client.clientOptionsDict
    const appLanguage = state.app.lang


    clientAccess.map((item, key) => {
        if (item.actionName == 'createmifid') {
            canCreateMifid = item.actionAllowed === "true" ? true: false
        }
    })

    return ({
        security: state.app.security,
        brokers: state.office.brokers,
        canCreateMifid,
        clientOptionsDict,
        appLanguage
    })
})

export default class ClientTarificationCreate extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            ...permanentState,
            ...resetableState,
            tarification: props.tarification,
        }
    }

    componentDidMount() {
        //here i need to do a check if the clientOptionsDicts are loaded if not to load them
        this.initializeBrokerOptions()
            .then(brokerOptions => {
                if(brokerOptions && brokerOptions.length === 1) {
                    this.handleBrokerChange(brokerOptions[0])
                }
            })
        this.initializeTeams()
    }

    /**
     * This function will set state for the broker selector input.
     * Insert the list of broker like an array contains plain JS objects (label, value).
     */
     initializeBrokerOptions() {
        const { brokers } = this.props
        const brokerOptions = brokers && Object.keys(brokers).map(brokerKey => ({
            value: brokers[brokerKey].brokerNumber,
            label: brokers[brokerKey].brokerNumber + " - " + brokers[brokerKey].main.name
        }))

        return new Promise((resolve, reject) => {
            this.setState({brokerOptions: brokerOptions}, () => {
                resolve(brokerOptions)
            })
        })
    }

    initializeTeams() {
        const {clientOptionsDict, appLanguage} = this.props
        const rawWillemotTeams = clientOptionsDict ? clientOptionsDict['TEAM_WILLEMOT'] : null
        const teams = []
        if(rawWillemotTeams){
            Object.keys(rawWillemotTeams).forEach(key => {
                teams.push({
                    value: key,
                    label: rawWillemotTeams[key][appLanguage]
                })
            })
            return new Promise((resolve, reject) => {
                this.setState({willemotTeams: teams}, () => {
                    resolve(teams)
                })
            })
        }
    }

    setFieldTouched(fieldName) {
        const { validationErrors } = this.state

        if (typeof fieldName == 'string') {
            nesProp.set(validationErrors, fieldName+'.touched', true)
        } else {
            Object.keys(fieldName).forEach((oneFieldName) => {
                nesProp.set(validationErrors, oneFieldName+'.touched', true)
            })
        }


        this.setState({validationErrors}, () => {
            // debug place
        })
    }

    handleBrokerChange = selectedBroker => {
        const selectedBrokerNumber = selectedBroker && selectedBroker.value || ''
        const oldBroker = nesProp.get(this.state, 'selectedBroker' )

        this.setFieldTouched('selectedBroker')

        //if there are no changes do nothing
        if( selectedBrokerNumber === oldBroker) {
            return
        }

        new Promise((resolve, reject) => {
            // change from nothing to a value, no popup required
            if (selectedBrokerNumber && !oldBroker) {
                return resolve()
            }

            // modal shown to ask user about if really want to clear the form
            this.switchWaitingModal(
                true,
                _("areYouSureToClearForm"),
                _("clearForm"),
                (shouldContinue = true) => {
                    if (shouldContinue) {
                        resolve()
                    } else {
                        this.switchWaitingModal(false)
                        reject()
                    }
                }
            )

        })
        .then(() => {
            //clear form
            this.resetForm()
                .then(() => {
                    // effect the broker change in the sate, after reseting form
                this.setState({ selectedBroker })
                })
        })
        .catch(()=>{
            // nothing to do because the confirmation modal canceled the operation by user
        })
    }

    handleTeamChange = tarificationTeam => {
        this.setState({tarificationTeam})
    }

    /**
     * This function handle the waiting modal
     * @param {bool} show - modal show or hide
     * @param {string} text - modal content
     * @param {string} title - modal title
     * @param {function} waitingModalOkButtonCallback is empty the no button shown, else ok button call
     */

    switchWaitingModal(show = true, text = "", title = "", waitingModalOkButtonCallback = null, waitingModalOkButtonLink = null) {
        this.setState({
            waitingModal: show,
            waitingModalText: text,
            waitingModalTitle: title,
            waitingModalOkButtonCallback: waitingModalOkButtonCallback,
            waitingModalOkButtonLink: waitingModalOkButtonLink,
        })
    }

    /**
     * This function will reset the variable values in the form fields
    */
    resetForm() {
        return new Promise((resolve) => {
            this.setState({
                ...resetableState,
            }, resolve)
        })
    }

    /**
     * This function
     * @param {*} isConfirmed
     */
     handleCloseModel(isConfirmed) {
        const { closeModal, dispatch, clientId } = this.props
        if (!isConfirmed) {
            this.setState(resetableState)
            return closeModal()
        }

        // prepare params for api call
        let createTarificationParams = {}
        createTarificationParams.clientId = clientId
        createTarificationParams.brokerNumber = nesProp.get(this.state ,"selectedBroker.value")
        createTarificationParams.tarificationTeam = nesProp.get(this.state , "tarificationTeam.value")

        // call the createCTarification api call
        dispatch(createClientTarification(createTarificationParams))
        .then((result) => {
            let error = nesProp.get(result[0] ,"error")
            if (error && String(error) !== '0' && String(error) !== '') {
                throw error
            }

            // show notification modal about error
            this.switchWaitingModal(
                true, _("createPremSuccessMessage"), _("createPremSuccessTitle"),
                (shouldContinue = true) => {
                    this.switchWaitingModal(false)
                    let tarificationNumber = nesProp.get(result ,"tarificationNumber")
                    let tarificationId = nesProp.get(result ,"tarificationId")

                    this.setState({tarificationId: tarificationId})
                    this.setState({tarificationNumber: tarificationNumber})

                    dispatch(fetchClientTarifications(clientId))
                    .then(()=>{
                        dispatch(fetchClientTarification(tarificationId))
                            .then(() => {
                                return this.setState({tarificationDetailLoaded: true}, () =>{
                                    dispatch(setOpenedSubmenu(tarificationId))
                                })
                            })
                    })

                    this.handleCloseModel(false)
                }
            )
        })
        .catch((err) => {
            let error = nesProp.get(err, "error")
            let errorCode = Number(error)

            // if error code not in the list then that is not recognized by the system and set
            // to the unknown error
            if ([1,2,3,4].indexOf(errorCode) == -1) {
                errorCode = 3
            }

            // show notification modal about error
            this.switchWaitingModal(
                true,
                _("createPrevErrorMessage" + errorCode),
                _("createPrevErrorTitle"),
                (shouldContinue = true) => {
                    this.switchWaitingModal(false)
                }
            )
        })
    }

    waitingPopup() {
        const {waitingModalText, waitingModalTitle, waitingModalOkButtonCallback, waitingModal} = this.state

        return (
            <Modal
                isOpen={waitingModal}
                style = {customStylesForModal}
                className = {styles.modal}
                key={"archiveConfirmPopupKey"}
                contentLabel={""}
            >
                <div className={styles.title}>{waitingModalTitle}</div>
                <div className={styles.contentWrapper}>
                    <div className={styles.content} key={"formContainerKey"}>
                        <div className={styles.whitespacePre}>{waitingModalText}</div>
                        {waitingModalOkButtonCallback && typeof waitingModalOkButtonCallback == 'function' &&
                            <div className={styles.buttons} key={"closeModalKey"}>
                                <div
                                    onClick={()=>(waitingModalOkButtonCallback(false))}
                                    className={styles.cancel}
                                >
                                    {_("cancel")}
                                </div>
                                <div
                                    className={cs(styles.next, styles.enabled)}
                                    onClick={()=>(waitingModalOkButtonCallback(true))}
                                >
                                    {_('ok')}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        )
    }

    render() {
        const {modalIsOpen, closeModal, canCreateMifid, tarificationId} = this.props
        const {brokerOptions, selectedBroker, hasError, willemotTeams, tarificationTeam} = this.state
        return (
            <div>
                <Modal
                    isOpen={modalIsOpen}
                    onCancel={closeModal}
                    style = {customStylesForModal}
                    className={styles.modal}
                    contentLabel = {""}
                >
                    <div className={styles.title}>
                        {_('createTarificationModalTitle')}
                    </div>
                    <div className={styles.contentWrapper} key={'contentWrapperKey'}>
                        <div className={styles.content} key={'formContainerKey'}>
                            <form className={styles.form}>
                                <div className={styles.inputRow} key={'brokerNumberKey'}>
                                    <label className={styles.inputLabel}>{_('brokerNumber')}</label>
                                    <ReactSelect2
                                        value={selectedBroker}
                                        onChange={(value => {
                                            return this.handleBrokerChange(value)
                                        })}
                                        options={brokerOptions}
                                        openMenuOnFocus={true}
                                        placeholder={''}
                                        onBlurResetsInput={false}
                                        isSearchable
                                        isClearable
                                    />
                                </div>
                                <div className={styles.inputRow} key={'willemotTeams'}>
                                    <label className={styles.inputLabel}>{_('willemotTeams')}</label>
                                    <ReactSelect2
                                        value={tarificationTeam}
                                        onChange={(value => {
                                            return this.handleTeamChange(value)
                                        })}
                                        options={willemotTeams}
                                        openMenuOnFocus={true}
                                        placeholder={''}
                                        onBlurResetsInput={false}
                                        isSearchable
                                        isClearable
                                    />
                                </div>
                                <div>

                                </div>
                                <div className={styles.buttons} key={"closeModalKey"}>
                                    <div
                                        key={"closeModalCanceKey"}
                                        onClick={()=>{this.handleCloseModel(false)}}
                                        className={cs(styles.cancel)}
                                    >
                                        {_("cancel")}
                                    </div>

                                    <div
                                        key={"closeModalConfirmKey"}
                                        onClick={()=>{
                                            if (!hasError) {
                                                this.handleCloseModel(true)
                                            } else {
                                                this.setFieldTouched(fieldsForFill)
                                            }
                                        }}
                                        className={cs(styles.next, styles.enabled)}
                                    >
                                        {_("confirm")}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>
                {this.waitingPopup()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clients/clientTarificationCreate.jsx